var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"IncomeDetailed container-inner"},[(this.$store.state.step == 1)?_c('slider-question',_vm._b({key:1},'slider-question',{
            title: 'Income',
            description: 'What is your total annual pre-tax income including super?<br> (This would determine the maximum cover you may able to apply for)',
            min: 0,
            type: 'money',
            format: 'thousands',
            max: 120000,
            tick: 40000,
            step: 1000,
            value: this.$store.state.income,
            customVal: this.$store.state.customIncome,
            name: 'income',
            customName: 'customIncome',
            previous: 1,
            next: 2
        },false)):_vm._e(),(this.$store.state.step == 2)?_c('slider-question',_vm._b({key:2},'slider-question',{
            title: 'Other Income',
            description: 'What is your annual after-tax income from sources other than your salary and wages? <br>(e.g.partner\'s income, investments, government support etc.)',
            note: 'Please note that any income from other sources could affect the maximum income protection benefit available to you.',
            min: 0,
            type: 'money',
            format: 'thousands',
            max: 20000,
            tick: 5000,
            step: 1000,
            value: this.$store.state.incomeOther,
            customVal: this.$store.state.customIncomeOther,
            name: 'incomeOther',
            customName: 'customIncomeOther',
            previous: 1,
            next: 3
        },false)):_vm._e(),(this.$store.state.step == 3)?_c('slider-question',_vm._b({key:3},'slider-question',{
            title: 'Debt Repayments',
            description: 'What is your estimated monthly debt repayment? <br>(e.g. mortgages, personal loans, etc.)',
            min: 0,
            type: 'money',
            format: 'thousands',
            max: 5000,
            tick: 1000,
            step: 250,
            value: this.$store.state.debtRepayment,
            customVal: this.$store.state.customDebtRepayment,
            name: 'debtRepayment',
            customName: 'customDebtRepayment',
            previous: 2,
            next: 4
        },false)):_vm._e(),(this.$store.state.step == 4)?_c('slider-question',_vm._b({key:4},'slider-question',{
            title: 'Expenses',
            description: 'What is your estimated weekly household spending beside debt repayments? <br>(e.g. groceries, utilities, school fees, etc.)',
            min: 0,
            type: 'money',
            max: 5000,
            tick: 1000,
            step: 250,
            value: this.$store.state.expenses,
            customVal: this.$store.state.customExpenses,
            name: 'expenses',
            customName: 'customExpenses',
            previous: 3,
            next: 'results'
        },false)):_vm._e()],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }